import { Component, Input } from '@angular/core';

import { LanguageCode } from '@language';
import { ApiFragment, BaseContainer, FieldDefinitionStub, ThesaurusApiTranslation } from '@stylehaven/components';
import { capitalize } from 'lodash-es';

@Component({
    standalone: false,
    selector: 'med-thesaurus-suggestion-detail',
    templateUrl: './thesaurus-suggestion-detail.component.html'
})
export class ThesaurusSuggestionDetailComponent extends BaseContainer {
    @Input() thesaurusSuggestion: ApiFragment;

    get thesaurusSuggestionLabel(): string {
        return this.thesaurusSuggestion.getTitle();
    }

    get thesaurusSuggestionSubmitter(): string | null {
        return this.thesaurusSuggestion.get('Descriptive', 'UploadedBy');
    }

    get thesaurusSuggestionScheme(): string | null {
        const fieldDefinition: FieldDefinitionStub = this.thesaurusSuggestion.get('Structural', 'FieldDefinition');

        if (this.isNotEmptyObject(fieldDefinition)) {
            const localLanguage: LanguageCode = this.translateService.getCurrentLanguage();

            return fieldDefinition.LongTranslations[capitalize(localLanguage)] || fieldDefinition.DottedKey;
        }

        return null;
    }

    get thesaurusPreferredLabels(): ThesaurusApiTranslation[] {
        return this.thesaurusSuggestion.get('RecordInformation', 'PreferredLabels')?.PreferredLabel ?? [];
    }

    get thesaurusAltLabels(): [string, string[]][] {
        const origLabels: ThesaurusApiTranslation[] =
            this.thesaurusSuggestion.get('RecordInformation', 'AlternativeLabels')?.AlternativeLabel ?? [];
        return Object.entries(
            origLabels.reduce((packed: Record<string, string[]>, current: ThesaurusApiTranslation) => {
                if (packed[current.Lang]) {
                    packed[current.Lang].push(current.Label);
                } else {
                    packed[current.Lang] = [current.Label];
                }
                return packed;
            }, {})
        );
    }

    private isNotEmptyObject<T extends {}>(input: T): input is T {
        return Object.keys(input).length > 0;
    }
}
